import { render, staticRenderFns } from "./addcustemdialog.vue?vue&type=template&id=70ba3b28&scoped=true"
import script from "./addcustemdialog.vue?vue&type=script&lang=js"
export * from "./addcustemdialog.vue?vue&type=script&lang=js"
import style0 from "./addcustemdialog.vue?vue&type=style&index=0&id=70ba3b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ba3b28",
  null
  
)

export default component.exports